import type { UseFormReturn } from 'react-hook-form';
import { ChannelPriceModifiers } from './ChannelPriceModifiers';
import { ConfigurationField, ConfigurationSwitch } from './ConfigurationField';
import { PriceRangeBar } from './PriceRangeBar';
import type { PricingConfigurationFormValues } from './pricingConfigurationSchema';

const PRICES = [
  ['minimumPrice', 'Mindestpreis'],
  ['referencePrice', 'Referenzpreis'],
  ['maximumPrice', 'Maximalpreis'],
] as const;

interface Props {
  propertyId?: string;
  form: UseFormReturn<PricingConfigurationFormValues>;
  currency: string;
  errorFor: (field: string) => string | undefined;
}

/** Abschnitt 2: Preisgrenzen mit Leiste, Nachlass-Schalter und Kanalpreise (getrennt gespeichert). */
export function PriceRulesSection({ propertyId, form, currency, errorFor }: Props) {
  const values = form.watch(['minimumPrice', 'referencePrice', 'maximumPrice']);
  return (
    <>
      <div className="grid gap-2.5 sm:grid-cols-3">
        {PRICES.map(([name, label]) => (
          <ConfigurationField
            key={name}
            label={label}
            type="number"
            inputMode="decimal"
            min="0.01"
            step="0.01"
            suffix={currency === 'EUR' ? '€' : currency}
            error={errorFor(name)}
            {...form.register(name)}
          />
        ))}
      </div>
      <PriceRangeBar
        minimum={values[0]}
        reference={values[1]}
        maximum={values[2]}
        currency={currency}
      />
      <span className="text-ink-soft text-xs">
        Die Automatik bleibt immer zwischen Mindest- und Maximalpreis. Reihenfolge: Mindestpreis ≤
        Referenzpreis ≤ Maximalpreis.
      </span>
      <div className="grid gap-2.5 sm:grid-cols-2">
        <ConfigurationSwitch
          label="Last-Minute-Nachlass erlauben"
          {...form.register('lastMinuteDiscountEnabled')}
        />
        <ConfigurationSwitch
          label="Nachlass für Lücken erlauben"
          {...form.register('gapDiscountEnabled')}
        />
      </div>
      {propertyId && <ChannelPriceModifiers propertyId={propertyId} currency={currency} />}
    </>
  );
}
